<template>
  <div class="flex flex-col mt-32">
    <div class="flex flex-wrap gap-4">
      <div
        class="flex-1 min-w-[280px] max-w-full sm:max-w-[calc(50%-0.5rem)] lg:max-w-[calc(25%-0.8rem)] mr-3 mt-3 mb-3"
        @click="activeForm = 'personalinfoform'"
      >
        <card-profile-form
          nameTitle="Personal Information"
          buttonText="Personal Information"
          :extraClasses="{ 'bg-red-500': errors.personal_information }"
        />
      </div>

      <div
        class="flex-1 min-w-[280px] max-w-full sm:max-w-[calc(50%-0.5rem)] lg:max-w-[calc(25%-0.8rem)] mr-3 mt-3 mb-3"
        @click="activeForm = 'termsform'"
      >
        <card-profile-form
          nameTitle="Terms and Agreement"
          buttonText="Terms and Agreement"
          :extraClasses="{ 'bg-red-500': errors.terms }"
        />
      </div>

      <div
        class="flex-1 min-w-[280px] max-w-full sm:max-w-[calc(50%-0.5rem)] lg:max-w-[calc(25%-0.8rem)] mr-3 mt-3 mb-3"
        @click="activeForm = 'signature'"
      >
        <card-profile-form
          nameTitle="Signature"
          buttonText="Signature"
          :extraClasses="{ 'bg-red-500': errors.signature }"
        />
        <template v-if="errors.signature"></template>
      </div>

      <div
        class="flex-1 min-w-[280px] max-w-full sm:max-w-[calc(50%-0.5rem)] lg:max-w-[calc(25%-0.8rem)] mr-3 mt-3 mb-3"
        @click="activeForm = 'resource_documents'"
      >
        <card-profile-form
          nameTitle="Resource Documents"
          buttonText="Resource Documents"
        />
      </div>
    </div>

    <div class="mt-4 w-full lg:w-2/3">
      <signature
        v-if="activeForm === 'signature'"
        @signature-updated="check_details"
      />
      <personal-information-form
        v-if="activeForm === 'personalinfoform'"
        @client-updated="check_details"
      />
      <terms-condition-agreement-form
        v-if="activeForm === 'termsform'"
        :accepted="!errors.terms"
        @terms-updated="check_details"
      />
      <resource-documents v-if="activeForm === 'resource_documents'" />
    </div>
  </div>
</template>

<script>
import PersonalInformationForm from "@/views/main/enrollmentform/PersonalInformationForm.vue";
import TermsConditionAgreementForm from "@/views/main/enrollmentform/TermsConditionAgreementForm.vue";
import Signature from "@/views/main/Signature.vue";
import ResourceDocuments from "@/views/main/enrollmentform/ResourceDocuments.vue";
import CardProfileForm from "@/components/Cards/CardProfileForm.vue";
import axios from "axios";

export default {
  name: "Enrollment",
  data() {
    return {
      iconBackground: "bg-gradient-success",
      activeForm: "personalinfoform",
      errors: {},
    };
  },
  components: {
    CardProfileForm,
    Signature,
    PersonalInformationForm,
    TermsConditionAgreementForm,
    ResourceDocuments,
  },
  methods: {
    async check_details() {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/client_documents_generate_validator`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.status === "error") {
          this.errors = response.data.errors;
        } else {
          this.errors = {};
        }
      } catch (error) {
        console.error("Backend error:", error);
      }
    },
  },
  mounted() {
    this.check_details();
  },
};
</script>
